module.exports = __webpack_public_path__ + "img/sami-halim-untitled.f5c8da6.jpg";